import { useEffect, useState } from 'react'
import { useAuthContext } from 'context/AuthContext'
import { FdcTrackerTableMetadataQuery } from 'schema'
import { useCheckPermission } from 'hooks/useCheckPermission'

/**
 * converts the supplied items into a map where the keys are the ids and the
 * values are whether the logged in user associated with the items
 *
 * i.e. whether the user can approve/concur/reject
 *
 * @param items {@link ApprovalGroup|approval} or {@link ConcurrenceGroup|concurrence} groups
 */
export function useBooleanMap(items?: ApprovalGroup[] | ConcurrenceGroup[]) {
  const { user } = useAuthContext()
  const admin = useCheckPermission('admin')
  const [map, setMap] = useState(new Map<string, boolean>())
  useEffect(() => {
    const reduced = (items ?? []).reduce(
      (map, { id, roles, users }) =>
        map.set(
          id,
          user?.implicitlyAuthorized({ users, roles }).authorized === true ||
            admin
        ),
      new Map<string, boolean>()
    )
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Stop-gap for existing behavior.
    setMap(reduced)
  }, [items, user, admin])
  return map
}

type Data = FdcTrackerTableMetadataQuery['project']
type ApprovalGroup = Omit<Data['fdcApprovalGroups'][0], '__typename'>
type ConcurrenceGroup = Omit<Data['fdcConcurrenceGroups'][0], '__typename'>
